import { z } from "zod";

const zTrialResult = z.enum(["PLAYER_1_WIN", "PLAYER_2_WIN", "DRAW", "ABORTED"]);

export const zTrialInput = z.object({
    player1Id: z.string().nullable(),
    player2Id: z.string().nullable(),
    finishedAt: z
        .string()
        .or(z.date())
        .transform(arg => new Date(arg))
        .nullable(),
    result: zTrialResult.nullable(),
});

export type TrialInput = z.infer<typeof zTrialInput>;
